import type { LabConfig, LabReport } from './types';

export async function exportReport(report: LabReport, config: LabConfig): Promise<void> {
  try {
    const res = await fetch(config.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(report),
    });
    if (!res.ok) {
      console.warn('Failed to upload report:', res.status, res.statusText);
    }
  } catch (err) {
    console.warn('Report upload failed:', err);
  }
}

// Keep the last report in memory for manual debugging from DevTools.
let lastReport: LabReport | null = null;

export function setLastReport(report: LabReport): void {
  lastReport = report;
  if (typeof window !== 'undefined') {
    (window as any).__lastReport = report;
  }
}

export function getLastReport(): LabReport | null {
  return lastReport;
}
